import React from 'react';
import { CheckCircle, X } from './Icons';

const LanguageSettings = ({ isOpen, onClose, preferences, onPreferencesChange }) => {
  if (!isOpen) return null;

  const languageOptions = [
    { id: 'traditional', name: '繁體中文', flag: '🇹🇼' },
    { id: 'simplified', name: '简体中文', flag: '🇨🇳' },
    { id: 'english', name: 'English', flag: '🇺🇸' }
  ];

  const studyDirections = [
    {
      id: 'zh_to_en',
      name: '中文 → English',
      description: '從中文學習英文'
    },
    {
      id: 'en_to_zh',
      name: 'English → 中文',
      description: '從英文學習中文'
    }
  ];

  return (
    <div className="fixed inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white z-50 overflow-y-auto">
      <div className="flex justify-between items-center p-6">
        <h1 className="text-2xl font-bold">語言設定</h1>
        <button onClick={onClose}>
          <X className="w-6 h-6" />
        </button>
      </div>

      {/* Display Language */}
      <div className="px-6 mb-8">
        <h2 className="text-lg font-semibold mb-4">介面語言</h2>
        <div className="space-y-3">
          {languageOptions.map((option) => (
            <button
              key={option.id}
              onClick={() => onPreferencesChange('displayLanguage', option.id)}
              className={`w-full p-4 rounded-xl border-2 flex items-center space-x-4 ${
                preferences.displayLanguage === option.id
                  ? 'border-blue-400 bg-blue-500/20'
                  : 'border-gray-600 bg-gray-800/30'
              }`}
            >
              <span className="text-2xl">{option.flag}</span>
              <span className="flex-1 text-left font-medium">{option.name}</span>
              {preferences.displayLanguage === option.id && (
                <CheckCircle className="w-6 h-6 text-blue-400" />
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Study Language */}
      <div className="px-6 mb-8">
        <h2 className="text-lg font-semibold mb-4">學習語言</h2>
        <div className="space-y-3">
          {languageOptions.map((option) => (
            <button
              key={option.id}
              onClick={() => onPreferencesChange('studyLanguage', option.id)}
              className={`w-full p-4 rounded-xl border-2 flex items-center space-x-4 ${
                preferences.studyLanguage === option.id
                  ? 'border-green-400 bg-green-500/20'
                  : 'border-gray-600 bg-gray-800/30'
              }`}
            >
              <span className="text-2xl">{option.flag}</span>
              <span className="flex-1 text-left font-medium">{option.name}</span>
              {preferences.studyLanguage === option.id && (
                <CheckCircle className="w-6 h-6 text-green-400" />
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Study Direction */}
      <div className="px-6 mb-8">
        <h2 className="text-lg font-semibold mb-4">學習方向</h2>
        <div className="space-y-3">
          {studyDirections.map((direction) => (
            <button
              key={direction.id}
              onClick={() => onPreferencesChange('studyDirection', direction.id)}
              className={`w-full p-4 rounded-xl border-2 text-left ${
                preferences.studyDirection === direction.id
                  ? 'border-purple-400 bg-purple-500/20'
                  : 'border-gray-600 bg-gray-800/30'
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-semibold">{direction.name}</h3>
                  <p className="text-gray-300 text-sm">{direction.description}</p>
                </div>
                {preferences.studyDirection === direction.id && (
                  <CheckCircle className="w-6 h-6 text-purple-400" />
                )}
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Voice Settings */}
      <div className="px-6 mb-8">
        <h2 className="text-lg font-semibold mb-4">語音設定</h2>
        <div className="space-y-3">
          {[
            { id: 'american', name: 'American English', flag: '🇺🇸' },
            { id: 'british', name: 'British English', flag: '🇬🇧' },
            { id: 'australian', name: 'Australian English', flag: '🇦🇺' }
          ].map((accent) => (
            <button
              key={accent.id}
              onClick={() => onPreferencesChange('voiceAccent', accent.id)}
              className={`w-full p-4 rounded-xl border-2 flex items-center space-x-4 ${
                preferences.voiceAccent === accent.id
                  ? 'border-orange-400 bg-orange-500/20'
                  : 'border-gray-600 bg-gray-800/30'
              }`}
            >
              <span className="text-2xl">{accent.flag}</span>
              <span className="flex-1 text-left font-medium">{accent.name}</span>
              {preferences.voiceAccent === accent.id && (
                <CheckCircle className="w-6 h-6 text-orange-400" />
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Save Button */}
      <div className="px-6 pb-8">
        <button 
          onClick={onClose}
          className="w-full py-4 bg-gradient-to-r from-blue-500 to-purple-500 rounded-xl font-semibold text-lg"
        >
          儲存設定
        </button>
      </div>
    </div>
  );
};

export default LanguageSettings;
